import {
  envKeys,
  openAiApiKeys,
  googleMapApiKeys,
} from "@smart/bridge-env-types-basic";
import { buildWebSocketGatewayDef } from "@smart/itops-constructs-basic";
import { buildNamespace } from "@smart/itops-types-basic";

import { system } from "./base";
import { cdn } from "./cloudfront";

export const webSocketGateway = buildWebSocketGatewayDef({
  envKeys,
  cdn,
  namespace: buildNamespace({ system, entity: "intake" }),
  prefix: "ws",
  lambdaKeys: ["voiceConversationWebSocket"],
  lambdas: {
    voiceConversationWebSocket: {
      pkg: "@smart/intake-voice-conversation-websocket-lambda",
      deployable: "voiceConversationWebSocket",
      routes: ["$connect", "$disconnect", "voiceMessage"],
      env: [...openAiApiKeys, ...googleMapApiKeys],
    },
  },
  port: 9102,
});
